import type { ResidentItem, ResidentNeed } from '@lmc/ts-common'
import type { GetBaseOptions } from 'api/requestsTypes/get'
import { getJSON } from 'common/services/api'
import type { LMCRequest as LmcRequest } from './types'

const list: LmcRequest<
  { result: ResidentItem[] },
  { anyStatus: boolean },
  GetBaseOptions
> = () => getJSON({ url: 'residents' })

const fetch: LmcRequest<
  { result: ResidentItem },
  { id: string },
  GetBaseOptions
> = ({ params }) => getJSON({ url: `/api/list/residents/${params?.id}` })

const needsList: LmcRequest<
  { result: ResidentNeed[] },
  { id: string },
  GetBaseOptions
> = ({ params }) => getJSON({ url: `/api/list/residents/${params?.id}/needs` })

export const residentsRequests = {
  list,
  fetch,
  needsList
}
